<template>
  <transition name="modal">
    <div v-if="SHARE_STATE.show" v-preventWindowScrolling class="modal-conteiner">
      <div
        class="modal-frame"
        @click.self="SET_MODAL_PARAMS({ type: 'SHARE', params: { show: false } })"
      >
        <div class="modal-inner-container">
          <div>
            <div>
              <form @submit.prevent="sendBill">
                <fieldset>
                  <div class="container margin-bottom-two">
                    <div>
                      <span>{{ $t('share.on.social.media') }}</span>
                    </div>
                    <socials-share
                      :url="SHARE_STATE.shareInfo.url"
                      :title="SHARE_STATE.shareInfo.title"
                      :description="SHARE_STATE.shareInfo.description"
                    />
                  </div>
                </fieldset>
                <fieldset>
                  <div v-if="SHARE_STATE.shareInfo.showForm" class="container">
                    <div>
                      <span>{{ $t('send.to.email') }}</span>
                    </div>
                    <InputEmail
                      ref="email"
                      v-model="email"
                      input-id="input-email"
                      :input-name="$t('send.to.email')"
                      :input-title="$t('indicate.electronic.mail')"
                      :input-header="$t('send.to.email')"
                      :input-placeholder="$t('enter.email')"
                      :button-text="$t('common.send')"
                      required
                      @buttonClicked="sendBill"
                    />
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

import HTTPService from '@/services/Http';

import InputEmail from '@/components/inputElements/InputEmail';
import SocialsShare from '@/components/otherElements/SocialsShare';

export default {
  name: 'SocialShareList',
  components: {
    InputEmail,
    SocialsShare,
  },
  data() {
    return {
      email: '',
    };
  },
  computed: {
    ...mapState({
      PROJECT_INFO: 'PROJECT_INFO',
      SHARE_STATE: state => state.MODALS.SHARE,
    }),
    isValid() {
      return this.$refs.email && !this.$refs.email.$v.$error && this.email.length;
    },
  },
  methods: {
    sendBill() {
      if (!this.isValid) {
        this.$alert({
          type: 'warning',
          text: this.$t('mistakes.in.form'),
        });
        return;
      }

      HTTPService.sendReceipt(this.SHARE_STATE.shareInfo.id, { recipient: this.email })
        .then(() => {
          this.email = '';

          this.$alert({
            type: 'golubok',
            text: this.$t('bill.sent.to.email'),
          });

          this.SET_MODAL_PARAMS({
            type: 'SHARE',
            params: { show: false },
          });
        })
        .catch(() => {
          this.$alert({
            type: 'warning',
            text: this.$t('server.error'),
          });
        });
    },
    ...mapMutations(['SET_MODAL_PARAMS']),
  },
};
</script>

<style lang="sass" scoped>
.modal-conteiner
    /* This way it could be display flex or grid or whatever also. */
    display: block

    /* Probably need media queries here */
    // width: 600px
    width: 100%
    max-width: 100%

    // height: 400px
    height: 100%
    max-height: 100%
    position: fixed
    z-index: 2000
    left: 50%
    top: 50%
    transform: translate(-50%, -50%)
    // background-color: #1E1D2F
    // background-color: rgba(30, 29, 47, .4)
.modal-frame
    position: absolute
    top: 0
    left: 0
    width: auto
    width: 100%
    left: 50%
    top: 50%
    transform: translate(-50%, -50%)
    height: 100%
    overflow: auto
    padding: 0 .64rem
    padding-top: 35vh
    @media (min-width: 32rem)
        padding: 0 1.28rem
        padding-top: 35vh
.modal-inner-container
    max-width: 36rem
    margin: auto
    // align-content: initial
    // min-height: 100vh
    // width: 100%
    > div
        flex-basis: 100%
        position: relative
        margin: calc(.64rem * 2) 0
        padding: 1.2rem 1.6rem 0
        border-radius: .8rem

        .eclipse &
          background-color: #E5E5E5
          border: 0.12rem solid #E5E5E5

        .obsidian &
          background-color: #181824
          border: 0.12rem solid #181824

        @media (min-width: 32rem)
            padding: 1.2rem 2.4rem 0
            margin: 2.4rem 0
        > div
            margin: 0
            @media (min-width: 32rem)
                margin: 1.2rem 0
.container
    > div
        flex-basis: 100%
        &:first-of-type
            font-size: 16px
            line-height: 22px
            margin-bottom: 1.2rem
            @media (min-width: 32rem)
                font-size: 18px

</style>
